// Icon options for the Haulback Reason Code and Route Roadblock admin modals.
// Each string is a valid react-native-vector-icons/MaterialIcons name.

// ── Haulback reason codes ──────────────────────────────────────────────────────
// Store Refusal        → do-not-disturb
// No Receiver          → person-off
// Store Closed         → lock
// Excess Backroom      → inventory-2
// Over Ordered         → production-quantity-limits
// Duplicate Order      → content-copy
// Wrong Product        → swap-horiz
// Invoice Discrepancy  → receipt-long
// Missed Stop / DOT    → timer-off
// Route Time Cut       → schedule
// Customer Reschedule  → event-repeat
// Truck Breakdown      → car-crash
// Lift Gate / Equip.   → construction
// Temperature Issue    → thermostat
// Dock Blocked         → block
// Security / Access    → no-encryption
// Damaged Product      → dangerous
// Other                → more-horiz

// ── Route roadblock reasons ────────────────────────────────────────────────────
// Road Closure         → remove-road
// Truck Breakdown      → car-crash          (shared)
// Trailer Seal Broken  → lock-open
// EPJ Not Charged      → battery-alert
// Severe Weather       → thunderstorm
// Traffic Delay        → traffic
// DOT Hours Limit      → timer-off          (shared)
// Vehicle Accident     → car-crash          (shared)
// Time Window Adj.     → schedule           (shared)
// Store Closed         → lock               (shared)
// No Receiver          → person-off         (shared)
// Dock Blocked         → block              (shared)
// Security / Access    → no-encryption      (shared)
// Cannot Locate Stop   → wrong-location
// Store Refusal        → do-not-disturb     (shared)

export const DELIVERY_RPM_ICON_OPTIONS: string[] = [
  // ── Refusals & access ─────────────────────────────────────────────────────
  'do-not-disturb',           // Store Refusal
  'no-encryption',            // Security / Access Denied
  'lock',                     // Store Closed
  'lock-open',                // Trailer Seal Missing / Broken
  'block',                    // Dock Blocked / Inaccessible

  // ── People / receiver ─────────────────────────────────────────────────────
  'person-off',               // No Receiver
  'person',                   // general person
  'groups',                   // team / crew

  // ── Inventory & orders ────────────────────────────────────────────────────
  'inventory',                // general inventory
  'inventory-2',              // Excess Backroom Inventory
  'production-quantity-limits', // Over Ordered
  'content-copy',             // Duplicate Order
  'swap-horiz',               // Wrong Product Delivered
  'receipt-long',             // Invoice Discrepancy
  'dangerous',                // Damaged Product

  // ── Time & scheduling ─────────────────────────────────────────────────────
  'timer-off',                // Missed Stop / DOT Hours Limit
  'schedule',                 // Route Time Cut / Time Window Adjustment
  'event-repeat',             // Customer Reschedule Request
  'more-time',                // time extension / adjustment

  // ── Vehicle & equipment ───────────────────────────────────────────────────
  'car-crash',                // Truck Breakdown / Vehicle Accident
  'local-shipping',           // truck / delivery vehicle
  'construction',             // Lift Gate / Equipment Failure
  'build',                    // mechanical repair
  'engineering',              // technical issue

  // ── Road & route ──────────────────────────────────────────────────────────
  'remove-road',              // Road Closure
  'traffic',                  // Traffic Delay
  'route',                    // general route
  'wrong-location',           // Cannot Locate Stop
  'map',                      // navigation
  'location-off',             // location unavailable

  // ── Weather & environment ─────────────────────────────────────────────────
  'thunderstorm',             // Severe Weather
  'wb-cloudy',                // overcast / weather
  'air',                      // wind / weather condition

  // ── Power & equipment state ───────────────────────────────────────────────
  'battery-alert',            // EPJ Not Charged
  'power-off',                // powered-down equipment

  // ── Temperature ───────────────────────────────────────────────────────────
  'thermostat',               // Temperature Issue
  'ac-unit',                  // cold / refrigeration
  'whatshot',                 // heat issue

  // ── Status & misc ─────────────────────────────────────────────────────────
  'more-horiz',               // Other
  'warning',                  // general warning
  'error-outline',            // error / issue
  'report-problem',           // problem report
  'info',                     // informational
  'flag',                     // flagged item
  'store',                    // store / location
];
